// Explicit, tree-shakeable registry of every lucide-react icon referenced
// dynamically (by string name) across the app — network logos, service-type
// icons and trust pills. Replaces `import * as Icons from "lucide-react"`
// (which pulled the ENTIRE icon library into the main bundle) with static
// named imports so webpack only bundles the ~30 icons actually used.
import {
  Instagram, Music2, Facebook, Youtube, Twitter, Ghost, Send, Linkedin,
  Twitch, AtSign, MessageSquare, Cloud, Globe,
  UserPlus, Users, Heart, Eye, PlayCircle, Link2, Image, ThumbsUp,
  MessageCircle, Share2, Radio, Star, Clock, Repeat2, Package,
  TrendingUp, Lock, ArrowDown, Headphones, Bookmark, Tv, Music,
} from "lucide-react";

export const ICONS = {
  Instagram, Music2, Facebook, Youtube, Twitter, Ghost, Send, Linkedin,
  Twitch, AtSign, MessageSquare, Cloud, Globe,
  UserPlus, Users, Heart, Eye, PlayCircle, Link2, Image, ThumbsUp,
  MessageCircle, Share2, Radio, Star, Clock, Repeat2, Package,
  TrendingUp, Lock, ArrowDown, Headphones, Bookmark, Tv, Music,
};
